import { render, staticRenderFns } from "./EditRule.vue?vue&type=template&id=35512684&scoped=true&"
import script from "./EditRule.vue?vue&type=script&lang=js&"
export * from "./EditRule.vue?vue&type=script&lang=js&"
import style0 from "./EditRule.vue?vue&type=style&index=0&id=35512684&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35512684",
  null
  
)

export default component.exports